import { render, staticRenderFns } from "./DrugDetails.vue?vue&type=template&id=563fd024&scoped=true&lang=pug&"
import script from "./DrugDetails.vue?vue&type=script&lang=ts&"
export * from "./DrugDetails.vue?vue&type=script&lang=ts&"
import style0 from "./DrugDetails.vue?vue&type=style&index=0&id=563fd024&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563fd024",
  null
  
)

export default component.exports